import * as React from 'react';

import * as Leads from 'nutshell-core/leads';

import {Button} from 'shells/button/button';
import {StageCarousel} from 'shells/lead/carousel/stage-carousel';
import {Body} from 'shells/typography/body';

import type {LeadStatus} from 'nutshell-graphql-types';
import type {GetLead_lead_stages_edges as StageEdge} from 'nutshell-graphql-types';

import {useGetSessionUser} from '../../core/use-get-session-user';

import {refetchForEvent} from '../refetch-helpers';

import {useUpdateLeadStage} from './graphql/hooks/use-update-lead-stage';

type Props = {
    leadId: string;
    isHot: boolean;
    pipelineName: string | null | undefined;
    pipelineId: string | null | undefined;
    stages: StageEdge[];
    leadStatus: LeadStatus;
    refetchLead: () => Promise<any>;
};

export function StageCarouselWrapper(props: Props) {
    // In rare cases, instances actually have a stageset
    // but some older leads don't have any. We want them
    // to be allowed to have a stageset.
    const defaultStagesetId = NutshellFrontendSettings.defaultStagesetId;

    const {user} = useGetSessionUser();
    const {updateLeadStage, isLoading: isUpdatingStage} = useUpdateLeadStage();

    const handleUpdateLeadStage = (stageId: string) => {
        return updateLeadStage(props.leadId, stageId).then(() => {
            if (NutClientConfig.hasLeadPageRedesignM3FF) {
                refetchForEvent('stageChanged');
                // Refetch old sales process steps to show any that were updated
                // @ts-expect-error
                if (window.Nut && window.Nut.modules && window.Nut.modules.Process) {
                    // @ts-expect-error
                    window.Nut.modules.Process.reloadProcesses();
                }
            } else {
                props.refetchLead();
                Timeline.refreshTimeline();
            }
        });
    };

    const handleSelectDefaultStageset = () => {
        return Leads.changeStageset(props.leadId, defaultStagesetId).then(() => {
            location.reload();
        });
        // TODO: handle errors
    };

    if (!props.pipelineName || !props.pipelineId) {
        return (
            <Body>
                This lead doesn’t have a pipeline.{' '}
                <Button
                    variant='text-primary'
                    size='xlarge'
                    noPadding={true}
                    onClick={handleSelectDefaultStageset}
                >
                    Use your default pipeline
                </Button>
            </Body>
        );
    }

    return (
        <StageCarousel
            leadId={props.leadId}
            isHot={props.isHot}
            pipelineName={props.pipelineName}
            pipelineId={props.pipelineId}
            stages={props.stages}
            onStageChange={handleUpdateLeadStage}
            isUpdatingStage={isUpdatingStage}
            leadStatus={props.leadStatus}
            canAccessSetup={Boolean(user && user.permissions.canAccessSetup)}
        />
    );
}
